import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../reducers/app.reducer';

export const appKey = 'app';

export const selectAppState = createFeatureSelector<AppState>(appKey);

export const selectLoading = createSelector(
  selectAppState,
  (state) => state.loading > 0
);

export const selectPending = createSelector(
  selectAppState,
  (state) => state.pending > 0
);

export const selectServices = createSelector(
  selectAppState,
  (state) => state.services
);

export const selectServiceByUrl = (url: string) =>
  createSelector(
    selectAppState,
    (state) => state?.services.filter((v) => v.url === ('/' + url))[0] || null
  );

export const selectSubpages = createSelector(
  selectAppState,
  (state) => state.subpages
);
